<template>
  <div id="app">
    <nav-bar />
    <router-view />
  </div>
</template>

<script>
import NavBar from './components/nav-bar.vue'

export default {
  name: 'app',
  components: {
    NavBar
  },
  data () {
    return {}
  }
}
</script>

<style>
</style>
